import type { LinkLikeProps } from '@slims-pro/ui/lib';
import { Link } from 'react-router';

/** `LinkLike` adapter: client-side navigation for links rendered by `@slims-pro/ui`. */
export function RouterLink({ href, ...rest }: LinkLikeProps) {
	return <Link to={href} {...rest} />;
}
